// extracted by mini-css-extract-plugin
export var dropdown = "_th-0";
export var imageWrapper = "_th-3";
export var itemNameContainer = "_th-1";
export var productImage = "_th-2";
export var spinnerWrapper = "_th-4";